// Load config based on environment
// Determine environment
// const env = process.env.PARCEL_ENV || 'local';
// console.log(`PARCEL_ENV: ${process.env.PARCEL_ENV}, env: ${env}`);

import config from './config.generated.json' assert { type: "json" };

export async function loadConfig() {
  // const response = await fetch(`/env/${env}/config.json`);
  // const config = await response.json();
  // console.log(`Loaded config: ${JSON.stringify(config)}`);
  // const config = {
  //   apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
  //   authDomain: import.meta.env.VITE_AUTH_DOMAIN || 'your-auth-domain',
  //   authClientId: import.meta.env.VITE_AUTH_CLIENT_ID || 'your-client-id',
  //   authAudience: import.meta.env.VITE_AUTH_AUDIENCE || 'your-audience',
  //   deeporbContractAddress: import.meta.env.VITE_DEEPORB_CONTRACT_ADDRESS || '0xYourContractAddress',
  //   network: import.meta.env.VITE_NETWORK || 'sepolia', // e.g., 'sepolia', 'mainnet'
  // };
  console.log(`Using config: ${JSON.stringify(config)}`);
  return config;
}

// module.exports = { loadConfig };

